<template>
  <div class="personal" v-loading="loading">
    <div class="main_top">
      <el-card class="panel-card m_t_left">
        <h3>
          <i class="el-icon-s-data"></i>业务统计
        </h3>
        <div class="stats-grid">
          <div class="m_box">
            <div class="m-img">
              <img src="../assets/a.png" alt />
            </div>
            <div class="m_box_cent">
              <h4>全部</h4>
              <p style="color:#2da1f9">{{ staticsData.count1 || 0 }}</p>
            </div>
          </div>
          <div class="m_box">
            <div class="m-img">
              <img src="../assets/b.png" alt />
            </div>
            <div class="m_box_cent">
              <h4>未入仓</h4>
              <p style="color:#67ca29">{{ staticsData.count2 || 0 }}</p>
            </div>
          </div>
          <div class="m_box">
            <div class="m-img">
              <img src="../assets/c.png" alt />
            </div>
            <div class="m_box_cent">
              <h4>未发货</h4>
              <p style="color:#fda005">{{ staticsData.count3 || 0 }}</p>
            </div>
          </div>
          <div class="m_box">
            <div class="m-img">
              <img src="../assets/d.png" alt />
            </div>
            <div class="m_box_cent">
              <h4>已发货</h4>
              <p style="color:#3ec6c4">{{ staticsData.count4 || 0 }}</p>
            </div>
          </div>
          <div class="m_box">
            <div class="m-img">
              <img src="../assets/e.png" alt />
            </div>
            <div class="m_box_cent">
              <h4>已清关</h4>
              <p style="color:#e07070">{{ staticsData.count5 || 0 }}</p>
            </div>
          </div>
          <div class="m_box">
            <div class="m-img">
              <img src="../assets/f.png" alt />
            </div>
            <div class="m_box_cent">
              <h4>已签收</h4>
              <p style="color:#4977fc">{{ staticsData.count6 || 0 }}</p>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="panel-card m_t_center">
        <h3><i class="el-icon-user"/>账号信息</h3>
        <div class="m_title">
          <img src="../assets/person.png" alt="" />
          <h2>{{ userData.username || '加载中...' }}</h2>
        </div>
        <div class="account-actions">
          <el-button size="mini" @click="toAccount">修改资料</el-button>
          <el-button size="mini" @click="toPassword">修改密码</el-button>
          <el-button size="mini" @click="autheDialog">实名认证</el-button>
          <el-button
            size="mini"
            @click="openWxDialog"
            v-if="userData.nickname">
            微信解绑
          </el-button>
          <el-button size="mini" @click="openWxDialog" v-else>微信绑定</el-button>
        </div>
        <ul class="m_btn">
          <li>
            <b>用户编号:</b>
            <span>{{ userData.userCode || '-' }}</span>
          </li>
          <li>
            <b>微信昵称:</b>
            <span v-if="userData.nickname" style="color:#409EFF;">{{ userData.nickname }}</span>
            <span v-else style="color:red;">未绑定微信</span>
          </li>
          <li>
            <b>账号状态:</b>
            <span v-if="accountStatusTxt === '正常'">{{ accountStatusTxt }}</span>
            <span v-else style="color:red;">{{ accountStatusTxt }}</span>
          </li>
          <li>
            <b>会员级别:</b>
            <span>{{ userData.userTypeTxt || '-' }}</span>
          </li>
          <li>
            <b>业务员:</b>
            <span>{{ userData.sellerName || '-' }}</span>
          </li>
          <li>
            <b>实名认证:</b>
            <span v-if="userData.userAuthe === '1'" style="color:#409EFF;">已认证</span>
            <span v-else style="color:red;">未认证</span>
          </li>
        </ul>
      </el-card>
      <el-card class="panel-card m_t_right">
        <h3><i class="el-icon-money"/>用户余额</h3>
        <ul class="m-btn">
          <li>
            <b>信用额度:</b>
            <span>{{ balanceData.credit || 0 }} 元</span>
          </li>
          <li>
            <b>剩余额度:</b>
            <span v-if="balanceData.remainingCredit >= 0">{{ balanceData.remainingCredit }} 元</span>
            <span v-else style="color:red;">{{ balanceData.remainingCredit }} 元</span>
          </li>
          <li>
            <b>总消费:</b>
            <span>{{ balanceData.totalConsumption || 0 }} 元</span>
          </li>
          <li>
            <b>待付款:</b>
            <span v-if="balanceData.obligations > 0" style="color:#F56C6C">{{ balanceData.obligations }} 元</span>
            <span v-else>{{ balanceData.obligations || 0 }} 元</span>
          </li>
        </ul>
      </el-card>
    </div>
    <div class="main_btn">
      <el-card class="panel-card m_b_left">
        <h3><i class="el-icon-warning-outline"/>问题件</h3>
        <div class="table-wrap">
          <el-table
            :data="abnormalData"
            class="table"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            border
            style="width:100%"
            max-height="400"
          >
            <el-table-column label="运单号" min-width="120">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="toOrderdeta(scope.row.orderNo)"
                >{{ scope.row.clientNo }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="问题件" prop="problemRemark" min-width="140"></el-table-column>
            <el-table-column label="订单日期" min-width="110">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime | dateformat('YYYY-MM-DD') }}</span>
              </template>
            </el-table-column>
            <template slot="empty">
              <span class="empty-tip">暂无问题件</span>
            </template>
          </el-table>
        </div>
      </el-card>
      <el-card class="panel-card m_b_center">
        <h3><i class="el-icon-download"/>文件下载</h3>
        <div class="table-wrap">
          <el-table
            :data="orderFileData"
            class="table"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            border
            style="width:100%"
            max-height="400"
          >
            <el-table-column label="运单号" prop="clientNo" min-width="120"></el-table-column>
            <el-table-column label="文件类型" min-width="120">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="file(scope.row)"
                >{{ scope.row.typeTxt }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="订单日期" min-width="110">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime | dateformat('YYYY-MM-DD') }}</span>
              </template>
            </el-table-column>
            <template slot="empty">
              <span class="empty-tip">暂无可下载文件</span>
            </template>
          </el-table>
        </div>
      </el-card>
      <el-card class="panel-card m_b_right">
        <h3><i class="el-icon-bell"/>物流通知</h3>
        <div class="table-wrap">
          <el-table
            :data="logstatusData"
            class="table"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            border
            style="width:100%"
            max-height="400"
          >
            <el-table-column label="运单号" min-width="120">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="toOrderdeta(scope.row.orderNo)"
                >{{ scope.row.clientNo }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="最新物流" prop="status" min-width="140"></el-table-column>
            <el-table-column label="发生时间" min-width="110">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime | dateformat('YYYY-MM-DD') }}</span>
              </template>
            </el-table-column>
            <template slot="empty">
              <span class="empty-tip">暂无物流通知</span>
            </template>
          </el-table>
        </div>
      </el-card>
    </div>
    <el-dialog
        title="实名认证"
        :visible.sync="autheDialogVisible"
        :close-on-click-modal="false"
        width="600px"
        class="auth-dialog">
        <div class="auth-content">
          <el-alert
            title="请上传身份证正反面照片"
            type="info"
            :closable="false"
            show-icon
            style="margin-bottom: 20px;">
          </el-alert>
          <el-upload
            style="text-align:center"
            class="upload-demo"
            :action="uploadAction"
            :headers="uploadHeaders"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-success="businessSuccess"
            :before-upload="beforeUpload"
            :limit="5"
            name="upload"
            ref="uploadDeliveryImgRef">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过2MB
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="autheDialogVisible = false">取消</el-button>
          <el-button 
            type="primary" 
            @click="waterSingle" 
            :loading="submitting"
            :disabled="deliveryImg.length === 0">
            提交认证
          </el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible" title="图片预览">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <el-dialog
        :visible.sync="msgDialogVisible"
        :close-on-click-modal="false"
        width="342px"
        :modal-append-to-body = "false">
        <Wxlogin
          v-if="wxConfigAvailable"
          id="wxLoginForm"
          :appid="appid"
          :scope="scope"
          :redirect_uri="redirect_uri"
        ></Wxlogin>
        <div v-else class="wx-config-error">
          微信功能暂不可用，请联系管理员配置
        </div>
      </el-dialog>
  </div>
</template>

<script>
//引入api
import httpApi from "../http/api";

import Wxlogin from "vue-wxlogin"
export default {
  name: "Personal",
  components: {
    Wxlogin // 声明引用组件
  },
  data() {
    return {
      balanceData: {},
      staticsData: {},
      abnormalData: [],
      orderFileData: [],
      logstatusData: [],
      userData: {},
      autheDialogVisible: false,
      dialogVisible: false,
      dialogImageUrl: '',
      deliveryImg: [],
      fileList: [],
      uploadHeaders: { token: sessionStorage.getItem('token') || '' },
      appid: "",
      scope: "snsapi_login",
      redirect_uri: "",
      msgDialogVisible: false,
      code: "",
      wxConfigAvailable: false,
      loading: false,
      submitting: false
    };
  },
  computed: {
    uploadAction() {
      return this.mApi + 'file/upload';
    },
    accountStatusTxt() {
      if (this.balanceData.remainingCredit != null && this.balanceData.remainingCredit < 0) {
        return '扣货中';
      }
      return this.userData.statusTxt || '-';
    }
  },
  methods: {
    //点击订单号跳往详情
    toOrderdeta(orderNo) {
      this.$router.push("/orderdetails/" + orderNo);
    },
    //文件下载
    file(row) {
      window.open(row.url);
    },
    //修改账号
    toAccount() {
      this.$router.push("/account");
    },
    toPassword() {
      this.$router.push("/changepass");
    },
    balanceM() {
      return httpApi.balanceM()
        .then(res => {
          if (res.data.code === "ok") {
            this.balanceData = res.data.data || {};
            const obligations = this.balanceData.obligations || 0;
            if (this.balanceData.credit === null || this.balanceData.credit === "") {
              this.balanceData.credit = 0;
              this.balanceData.remainingCredit = 0;
            } else {
              this.balanceData.remainingCredit = (this.balanceData.credit * 1000 - obligations * 1000) / 1000;
            }
          } else {
            this.$message.error(res.data.message || "获取余额信息失败");
          }
        })
        .catch(error => {
          console.error("获取余额信息异常:", error);
          this.$message.error("获取余额信息失败，请稍后重试");
        });
    },
    staticsM() {
      return httpApi.staticsM()
        .then(res => {
          if (res.data.code === "ok") {
            this.staticsData = res.data.data || {};
          } else {
            this.$message.error(res.data.message || "获取业务统计失败");
          }
        })
        .catch(error => {
          console.error("获取业务统计异常:", error);
          this.$message.error("获取业务统计失败，请稍后重试");
        });
    },
    abnormal() {
      return httpApi.abnormal()
        .then(res => {
          if (res.data.code === "ok") {
            this.abnormalData = res.data.data || [];
          } else {
            this.$message.error(res.data.message || "获取问题件失败");
          }
        })
        .catch(error => {
          console.error("获取问题件异常:", error);
          this.$message.error("获取问题件失败，请稍后重试");
        });
    },
    orderFile() {
      return httpApi.orderFile()
        .then(res => {
          if (res.data.code === "ok") {
            this.orderFileData = (res.data.data && res.data.data.rows) || [];
          } else {
            this.$message.error(res.data.message || "获取文件列表失败");
          }
        })
        .catch(error => {
          console.error("获取文件列表异常:", error);
          this.$message.error("获取文件列表失败，请稍后重试");
        });
    },
    autheDialog() {
      this.deliveryImg = [];
      this.autheDialogVisible = true;
    },
    logstatus() {
      return httpApi.logstatus()
        .then(res => {
          if (res.data.code === "ok") {
            this.logstatusData = res.data.data || [];
          } else {
            this.$message.error(res.data.message || "获取通知信息失败");
          }
        })
        .catch(error => {
          console.error("获取通知信息异常:", error);
          this.$message.error("获取通知信息失败，请稍后重试");
        });
    },
    getUser() {
      return httpApi.getUser()
        .then(res => {
          if (res.data.code === "ok") {
            this.userData = res.data.data || {};
            if (this.userData.findUserFileResponseList && Array.isArray(this.userData.findUserFileResponseList)) {
              this.fileList = this.userData.findUserFileResponseList.map(v => ({
                name: v.name,
                url: v.url
              }));
            } else {
              this.fileList = [];
            }
            return this.bindingWeixin();
          }
          this.$message.error(res.data.message || "获取用户信息失败");
        })
        .catch(error => {
          console.error("获取用户信息异常:", error);
          this.$message.error("获取用户信息失败，请稍后重试");
        });
    },
    handlePictureCardPreview(file){
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    businessSuccess(response) {
      const data = response && response.data;
      if (data && data.url) {
        this.deliveryImg.push(data.url);
      }
    },
    beforeUpload(file) {
      this.uploadHeaders = { token: sessionStorage.getItem('token') || '' };
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/bmp'];
      const isAllowed = allowedTypes.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isAllowed) {
        this.$message.error('只能上传 jpeg、jpg、png、bmp 格式的图片');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isAllowed && isLt2M;
    },
    waterSingle() {
      if (this.deliveryImg.length === 0) {
        this.$message.warning("请先上传认证图片");
        return;
      }
      
      this.submitting = true;
      httpApi
        .userAuthe({
          params: {
            username: this.userData.id,
            imgUrl: this.deliveryImg.join(',')
          }
        })
        .then(res => {
          if (res.data.code === "ok") {
            this.$message.success("认证成功！");
            this.autheDialogVisible = false;
            this.$router.go(0);
          } else {
            this.$message.error(res.data.message || "认证失败");
          }
        })
        .catch(error => {
          console.error("提交认证异常:", error);
          this.$message.error("提交认证失败，请稍后重试");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    initWeixin() {
      return httpApi
        .listParams({
          params: {
            type: "sys_weixin",
            enable: "1",
          },
        })
        .then((res) => {
          const weixinConfig = (res.data.data || []).find(row => (row.wxType || "").trim() === "website");
          if (res.data.code === "ok" && weixinConfig && weixinConfig.appid && weixinConfig.encodeUrl) {
            const protocol = window.location.protocol === 'https:' ? 'https://' : 'http://';
            this.redirect_uri = encodeURIComponent(protocol + weixinConfig.encodeUrl + "/personal");
            this.appid = weixinConfig.appid;
            this.wxConfigAvailable = true;
          } else {
            this.wxConfigAvailable = false;
            console.warn("未配置微信网站应用，或缺少 appid / 授权回调域");
          }
        })
        .catch(error => {
          this.wxConfigAvailable = false;
          console.error("获取微信配置异常:", error);
        });
    },
    openWxDialog() {
      if (!this.wxConfigAvailable) {
        this.$message.warning("微信绑定暂未开通，请联系管理员配置网站应用");
        return;
      }
      this.msgDialogVisible = true;
    },
    bindingWeixin() {
      if (!this.wxConfigAvailable || !this.code || !this.code.trim()) {
        return Promise.resolve();
      }

      const request = this.userData.nickname
        ? httpApi.unbindWeixin({ params: { code: this.code } })
        : httpApi.bindingWeixin({ params: { code: this.code } });

      return request
        .then(res => {
          if (res.data.code === "ok") {
            this.$message.success(this.userData.nickname ? "解绑成功！" : "绑定成功！");
            this.$router.go(0);
          } else {
            this.$message.error(res.data.message || (this.userData.nickname ? "解绑失败" : "绑定失败"));
          }
        })
        .catch(error => {
          console.error("微信绑定/解绑异常:", error);
          this.$message.error(this.userData.nickname ? "解绑失败，请稍后重试" : "绑定失败，请稍后重试");
        });
    },
    async loadPageData() {
      this.loading = true;
      try {
        await this.initWeixin();
        await this.getUser();
        await Promise.all([
          this.staticsM(),
          this.abnormal(),
          this.orderFile(),
          this.logstatus(),
          this.balanceM()
        ]);
      } catch (error) {
        console.error("页面数据加载异常:", error);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.code = this.$route.query.code || '';
    this.loadPageData();
  }
};
</script>

<style lang="less" scoped>
.personal {
  width: 100%;
  box-sizing: border-box;
  padding: 0 4px 16px;
}

.main_top,
.main_btn {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
  box-sizing: border-box;
}

.main_top {
  margin-bottom: 16px;
}

.main_btn {
  min-height: 0;
}

.panel-card {
  margin: 0;
  min-width: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  /deep/ .el-card__body {
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  h3 {
    text-align: left;
    font-size: 14px;
    margin: 0 0 12px;
    flex-shrink: 0;
    i {
      font-size: 14px;
      font-weight: bold;
      margin-right: 4px;
    }
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 8px;
  flex: 1;
}

.m_box {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 8px;

  .m-img {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    img {
      display: block;
      width: 44px;
      height: 44px;
    }
  }

  .m_box_cent {
    min-width: 0;
    flex: 1;
    h4 {
      margin: 0 0 4px;
      font-size: 13px;
      font-weight: 500;
      color: #606266;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.m_title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  min-width: 0;
  img {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
  }
  h2 {
    margin: 0;
    font-size: 20px;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.account-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;

  .el-button {
    margin: 0;
  }
}

.m_btn {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;

  li {
    display: flex;
    align-items: center;
    min-width: 0;
    line-height: 1.4;
    text-align: left;
    b {
      flex-shrink: 0;
      width: 70px;
      font-weight: 600;
      color: #606266;
    }
    span {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.m-btn {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;

  li {
    display: flex;
    align-items: baseline;
    min-width: 0;
    text-align: left;
    b {
      flex-shrink: 0;
      width: 70px;
      font-weight: 600;
      color: #606266;
      text-align: right;
    }
    span {
      margin-left: 8px;
      font-size: 18px;
      font-weight: 600;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.table-wrap {
  width: 100%;
  margin-top: 8px;
  overflow-x: auto;
  flex: 1;
  min-height: 0;

  .table {
    width: 100% !important;
  }
}

/deep/ .el-table .cell {
  text-align: center;
}

/deep/ .el-table th > .cell {
  text-align: center !important;
  font-size: 12px;
}

.empty-tip {
  display: inline-block;
  text-align: center;
  color: #909399;
  padding: 20px;
  font-size: 14px;
}

.auth-dialog {
  .auth-content {
    margin: 20px 0;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .wx-config-error {
    text-align: center;
    color: #909399;
    font-size: 14px;
    padding: 20px;
  }
}

.upload-demo {
  width: 100%;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

/* 中屏：两列 */
@media (max-width: 1280px) {
  .main_top,
  .main_btn {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .m_t_right,
  .m_b_right {
    grid-column-start: 1;
    grid-column-end: -1;
  }
  /* 余额通栏时横向铺开，避免大片留白 */
  .m_t_right .m-btn {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px 16px;
  }
  .m_t_right .m-btn li {
    flex-direction: column;
    align-items: flex-start;
  }
  .m_t_right .m-btn li b {
    width: auto;
    text-align: left;
    margin-bottom: 4px;
  }
  .m_t_right .m-btn li span {
    margin-left: 0;
  }
}

/* 窄屏：单列；统计 2 列 */
@media (max-width: 900px) {
  .main_top,
  .main_btn {
    grid-template-columns: 1fr;
  }
  .m_t_right,
  .m_b_right {
    grid-column: auto;
  }
  .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .m_btn {
    grid-template-columns: 1fr;
  }
  .m-btn li b {
    text-align: left;
  }
  .m_t_right .m-btn {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .m_t_right .m-btn li {
    flex-direction: row;
    align-items: baseline;
  }
  .m_t_right .m-btn li b {
    width: 70px;
  }
  .m_t_right .m-btn li span {
    margin-left: 8px;
  }
  .table-wrap .table {
    min-width: 360px;
  }
}

/* 更窄：统计单列 */
@media (max-width: 520px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  .account-actions .el-button {
    flex: 1 1 calc(50% - 8px);
  }
  /deep/ .auth-dialog.el-dialog {
    width: 92% !important;
  }
}
</style>